import Vue from 'vue'
import Router from 'vue-router'
import authBlock from '@/components/auth'
import RecoveryPassword from '@/components/recovery_password'
import CheckRecoveryPassword from '@/components/check_recovery_password'
import AquazorUsers from '@/components/aquazor-users'
import UserCabinet from '@/components/user-cabinet'
import Statistic from '@/components/statistic'
import AquazorSettings from '@/components/aquazor-settings'
import auth from '@/auth.js'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'auth', component: authBlock, beforeEnter: leaveAuthPage},
        { path: '/recovery-password', name: 'recovery-password', component: RecoveryPassword, beforeEnter: leaveAuthPage},
        { path: '/check-recovery-password/:recovert_code', name: 'check-recovery-password', component: CheckRecoveryPassword, beforeEnter: leaveAuthPage},
        { path: '/user-cabinet', name: 'user-cabinet', component: UserCabinet, beforeEnter: requireAuth},
        { path: '/aquazor-users', name: 'aquazor-users', component: AquazorUsers, beforeEnter: requireAuth },
        { path: '/statistic', name: 'statistic', component: Statistic, beforeEnter: requireAuth },
        { path: '/aquazor-settings', name: 'aquazor-settings', component: AquazorSettings, beforeEnter: requireAuth },
    ]
})

function requireAuth (to, from, next) {
  if (!auth.loggedIn(to.name)) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function leaveAuthPage (to, from, next) {
    if (!auth.loggedIn()) {
        next()
    } else {
      next({
        path: '/aquazor-users'
      })
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js